// Getting date as MMDDYYYY without separation and returns YYYY-MM-DD
export const formatDateToAPI = (date) => {
  return `${date.slice(4, 8)}-${date.slice(0, 2)}-${date.slice(2, 4)}`
}

// Getting date as MMDDYYYYHHmm without separation and returns YYYY-MM-DD HH:MM
export const formatDateWithHourToAPI = (date) => {
  return `${date.slice(4, 8)}-${date.slice(0, 2)}-${date.slice(2, 4)} ${date.slice(8, 10)}:${date.slice(10, 12)}`
}